import { render } from "./AmountFunds.vue?vue&type=template&id=3a0643ab&scoped=true"
import script from "./AmountFunds.vue?vue&type=script&lang=js"
export * from "./AmountFunds.vue?vue&type=script&lang=js"

import "./AmountFunds.vue?vue&type=style&index=0&id=3a0643ab&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0643ab"]])

export default __exports__